self["MonacoEnvironment"] = (function (paths) {
      function stripTrailingSlash(str) {
        return str.replace(/\/$/, '');
      }
      return {
        globalAPI: true,
        getWorkerUrl: function (moduleId, label) {
          var pathPrefix = typeof __webpack_public_path__ === 'string' ? __webpack_public_path__ : "";
          var result = (pathPrefix ? stripTrailingSlash(pathPrefix) + '/' : '') + paths[label];
          if (/^((http:)|(https:)|(file:)|(\/\/))/.test(result)) {
            var currentUrl = String(window.location);
            var currentOrigin = currentUrl.substr(0, currentUrl.length - window.location.hash.length - window.location.search.length - window.location.pathname.length);
            if (result.substring(0, currentOrigin.length) !== currentOrigin) {
              if(/^(\/\/)/.test(result)) {
                result = window.location.protocol + result
              }
              var js = '/*' + label + '*/importScripts("' + result + '");';
              var blob = new Blob([js], { type: 'application/javascript' });
              return URL.createObjectURL(blob);
            }
          }
          return result;
        }
      };
    })({
  "editorWorkerService": "editor.worker.js",
  "css": "css.worker.js",
  "html": "html.worker.js",
  "json": "json.worker.js",
  "typescript": "ts.worker.js",
  "javascript": "ts.worker.js",
  "less": "css.worker.js",
  "scss": "css.worker.js",
  "handlebars": "html.worker.js",
  "razor": "html.worker.js"
});
import "./contrib/anchorSelect/browser/anchorSelect.js";
import "./contrib/bracketMatching/browser/bracketMatching.js";
import "./browser/coreCommands.js";
import "./contrib/caretOperations/browser/caretOperations.js";
import "./contrib/caretOperations/browser/transpose.js";
import "./contrib/clipboard/browser/clipboard.js";
import "./contrib/codeAction/browser/codeActionContributions.js";
import "./contrib/codelens/browser/codelensController.js";
import "./contrib/colorPicker/browser/colorContributions.js";
import "./contrib/colorPicker/browser/standaloneColorPickerActions.js";
import "./contrib/comment/browser/comment.js";
import "./contrib/contextmenu/browser/contextmenu.js";
import "./contrib/cursorUndo/browser/cursorUndo.js";
import "./browser/widget/diffEditor/diffEditor.contribution.js";
import "./contrib/dnd/browser/dnd.js";
import "./contrib/documentSymbols/browser/documentSymbols.js";
import "./contrib/dropOrPasteInto/browser/copyPasteContribution.js";
import "./contrib/dropOrPasteInto/browser/dropIntoEditorContribution.js";
import "./contrib/find/browser/findController.js";
import "./contrib/folding/browser/folding.js";
import "./contrib/fontZoom/browser/fontZoom.js";
import "./contrib/format/browser/formatActions.js";
import "./contrib/gotoError/browser/gotoError.js";
import "./standalone/browser/quickAccess/standaloneGotoLineQuickAccess.js";
import "./contrib/gotoSymbol/browser/goToCommands.js";
import "./contrib/gotoSymbol/browser/link/goToDefinitionAtPosition.js";
import "./contrib/hover/browser/hover.js";
import "./standalone/browser/iPadShowKeyboard/iPadShowKeyboard.js";
import "./contrib/inPlaceReplace/browser/inPlaceReplace.js";
import "./contrib/indentation/browser/indentation.js";
import "./contrib/inlayHints/browser/inlayHintsContribution.js";
import "./contrib/inlineCompletions/browser/inlineCompletions.contribution.js";
import "./contrib/inlineProgress/browser/inlineProgress.js";
import "./standalone/browser/inspectTokens/inspectTokens.js";
import "./contrib/lineSelection/browser/lineSelection.js";
import "./contrib/linesOperations/browser/linesOperations.js";
import "./contrib/linkedEditing/browser/linkedEditing.js";
import "./contrib/links/browser/links.js";
import "./contrib/longLinesHelper/browser/longLinesHelper.js";
import "./contrib/multicursor/browser/multicursor.js";
import "./contrib/parameterHints/browser/parameterHints.js";
import "./standalone/browser/quickAccess/standaloneCommandsQuickAccess.js";
import "./standalone/browser/quickAccess/standaloneHelpQuickAccess.js";
import "./standalone/browser/quickAccess/standaloneGotoSymbolQuickAccess.js";
import "./contrib/readOnlyMessage/browser/contribution.js";
import "./standalone/browser/referenceSearch/standaloneReferenceSearch.js";
import "./contrib/rename/browser/rename.js";
import "./contrib/semanticTokens/browser/documentSemanticTokens.js";
import "./contrib/semanticTokens/browser/viewportSemanticTokens.js";
import "./contrib/smartSelect/browser/smartSelect.js";
import "./contrib/snippet/browser/snippetController2.js";
import "./contrib/stickyScroll/browser/stickyScrollContribution.js";
import "./contrib/suggest/browser/suggestController.js";
import "./contrib/suggest/browser/suggestInlineCompletions.js";
import "./standalone/browser/toggleHighContrast/toggleHighContrast.js";
import "./contrib/toggleTabFocusMode/browser/toggleTabFocusMode.js";
import "./contrib/tokenization/browser/tokenization.js";
import "./contrib/unicodeHighlighter/browser/unicodeHighlighter.js";
import "./contrib/unusualLineTerminators/browser/unusualLineTerminators.js";
import "./contrib/wordHighlighter/browser/wordHighlighter.js";
import "./contrib/wordOperations/browser/wordOperations.js";
import "./contrib/wordPartOperations/browser/wordPartOperations.js";

import * as monaco from "!!./editor.api.js";
export * from "!!./editor.api.js";
export default monaco;
		
import "../basic-languages/abap/abap.contribution.js";
import "../basic-languages/apex/apex.contribution.js";
import "../basic-languages/azcli/azcli.contribution.js";
import "../basic-languages/bat/bat.contribution.js";
import "../basic-languages/bicep/bicep.contribution.js";
import "../basic-languages/cameligo/cameligo.contribution.js";
import "../basic-languages/clojure/clojure.contribution.js";
import "../basic-languages/coffee/coffee.contribution.js";
import "../basic-languages/cpp/cpp.contribution.js";
import "../basic-languages/csharp/csharp.contribution.js";
import "../basic-languages/csp/csp.contribution.js";
import "../basic-languages/css/css.contribution.js";
import "../language/css/monaco.contribution.js";
import "../basic-languages/cypher/cypher.contribution.js";
import "../basic-languages/dart/dart.contribution.js";
import "../basic-languages/dockerfile/dockerfile.contribution.js";
import "../basic-languages/ecl/ecl.contribution.js";
import "../basic-languages/elixir/elixir.contribution.js";
import "../basic-languages/flow9/flow9.contribution.js";
import "../basic-languages/freemarker2/freemarker2.contribution.js";
import "../basic-languages/fsharp/fsharp.contribution.js";
import "../basic-languages/go/go.contribution.js";
import "../basic-languages/graphql/graphql.contribution.js";
import "../basic-languages/handlebars/handlebars.contribution.js";
import "../basic-languages/hcl/hcl.contribution.js";
import "../basic-languages/html/html.contribution.js";
import "../language/html/monaco.contribution.js";
import "../basic-languages/ini/ini.contribution.js";
import "../basic-languages/java/java.contribution.js";
import "../basic-languages/javascript/javascript.contribution.js";
import "../language/json/monaco.contribution.js";
import "../basic-languages/julia/julia.contribution.js";
import "../basic-languages/kotlin/kotlin.contribution.js";
import "../basic-languages/less/less.contribution.js";
import "../basic-languages/lexon/lexon.contribution.js";
import "../basic-languages/liquid/liquid.contribution.js";
import "../basic-languages/lua/lua.contribution.js";
import "../basic-languages/m3/m3.contribution.js";
import "../basic-languages/markdown/markdown.contribution.js";
import "../basic-languages/mdx/mdx.contribution.js";
import "../basic-languages/mips/mips.contribution.js";
import "../basic-languages/msdax/msdax.contribution.js";
import "../basic-languages/mysql/mysql.contribution.js";
import "../basic-languages/objective-c/objective-c.contribution.js";
import "../basic-languages/pascal/pascal.contribution.js";
import "../basic-languages/pascaligo/pascaligo.contribution.js";
import "../basic-languages/perl/perl.contribution.js";
import "../basic-languages/pgsql/pgsql.contribution.js";
import "../basic-languages/php/php.contribution.js";
import "../basic-languages/pla/pla.contribution.js";
import "../basic-languages/postiats/postiats.contribution.js";
import "../basic-languages/powerquery/powerquery.contribution.js";
import "../basic-languages/powershell/powershell.contribution.js";
import "../basic-languages/protobuf/protobuf.contribution.js";
import "../basic-languages/pug/pug.contribution.js";
import "../basic-languages/python/python.contribution.js";
import "../basic-languages/qsharp/qsharp.contribution.js";
import "../basic-languages/r/r.contribution.js";
import "../basic-languages/razor/razor.contribution.js";
import "../basic-languages/redis/redis.contribution.js";
import "../basic-languages/redshift/redshift.contribution.js";
import "../basic-languages/restructuredtext/restructuredtext.contribution.js";
import "../basic-languages/ruby/ruby.contribution.js";
import "../basic-languages/rust/rust.contribution.js";
import "../basic-languages/sb/sb.contribution.js";
import "../basic-languages/scala/scala.contribution.js";
import "../basic-languages/scheme/scheme.contribution.js";
import "../basic-languages/scss/scss.contribution.js";
import "../basic-languages/shell/shell.contribution.js";
import "../basic-languages/solidity/solidity.contribution.js";
import "../basic-languages/sophia/sophia.contribution.js";
import "../basic-languages/sparql/sparql.contribution.js";
import "../basic-languages/sql/sql.contribution.js";
import "../basic-languages/st/st.contribution.js";
import "../basic-languages/swift/swift.contribution.js";
import "../basic-languages/systemverilog/systemverilog.contribution.js";
import "../basic-languages/tcl/tcl.contribution.js";
import "../basic-languages/twig/twig.contribution.js";
import "../basic-languages/typescript/typescript.contribution.js";
import "../language/typescript/monaco.contribution.js";
import "../basic-languages/vb/vb.contribution.js";
import "../basic-languages/wgsl/wgsl.contribution.js";
import "../basic-languages/xml/xml.contribution.js";
import "../basic-languages/yaml/yaml.contribution.js";